export interface Position {
  x: number;
  y: number;
}

export interface RelativePosition {
  rightPercent: number;
  bottomPercent: number;
}

export interface ElementSize {
  width: number;
  height: number;
}

export const getPositionFromRelative = (
  relative: RelativePosition,
  elementSize: ElementSize
): Position => {
  const x = window.innerWidth * (1 - relative.rightPercent) - elementSize.width;
  const y = window.innerHeight * (1 - relative.bottomPercent) - elementSize.height;

  return {
    x: Math.max(0, Math.min(x, window.innerWidth - elementSize.width)),
    y: Math.max(0, Math.min(y, window.innerHeight - elementSize.height)),
  };
};

export const getRelativeFromPosition = (
  position: Position,
  elementSize: ElementSize
): RelativePosition => {
  return {
    rightPercent: 1 - (position.x + elementSize.width) / window.innerWidth,
    bottomPercent: 1 - (position.y + elementSize.height) / window.innerHeight,
  };
};
